export const i18nKeys = {
    'compareLayer.currency.minPriceWithVAT': 'von {{value}}',
    'compareLayer.currency.priceWithVAT': '{{value}}',
    'compareLayer.currency.priceExcludingVAT': '{{value}}',
    'compareLayer.currency.priceWithOptionalVAT': '{{value}}',
    'compareLayer.currency.monthlyRate': '{{value}}/Month',
    'compareLayer.header.compare': 'Compare',
    'compareLayer.header.select.label': 'Select trim line & engine',
    'compareLayer.header.add.label': 'Add to configuration',
    'compareLayer.header.included.label': 'Included in configuration',
    'compareLayer.header.showDifferences': 'Only show differences',
    'compareLayer.header.standardEquipment': 'Standard equipment',
    'compareLayer.header.technicalData': 'Technical data',
    'compareLayer.header.price.or': 'or',
    'compareLayer.header.tagSelection.title': 'Explore by category',
    'compareLayer.header.tagSelection.subTitle': 'Select which categories you would like to see:',
    'compareLayer.header.tagSelection.showLess': 'Show less',
    'compareLayer.header.tagSelection.showMore': 'Show more',
    'compareLayer.header.tagSelection.resetFilters': 'Reset filters',
    'compareLayer.technicalData.fuelType.petrol': 'Petrol',
    'compareLayer.technicalData.fuelType.diesel': 'Diesel',
    'compareLayer.technicalData.fuelType.power': 'Power',
    'compareLayer.technicalData.brakeSystem': 'Brake System',
    'compareLayer.technicalData.wltpUrl': '',
    'compareLayer.technicalData.carlineModel': '{{carline}} with {{model}}',
    'compareLayer.technicalData.consumptionAndEmission.fuelType': 'Fuel Type',
    'compareLayer.technicalData.consumptionAndEmission': 'Consumption and Emission (WLTP)',
    'compareLayer.technicalData.consumption': 'Consumption',
    'compareLayer.technicalData.driveline': 'Driveline',
    'compareLayer.technicalData.electricDrive': 'Electric Drive',
    'compareLayer.technicalData.combustionDrive': 'Combustion engine',
    'compareLayer.technicalData.engine': 'Engine',
    'compareLayer.technicalData.insuranceClasses': 'Insurance Classes',
    'compareLayer.technicalData.landingGear': 'Suspension',
    'compareLayer.technicalData.noiseLevel': 'Noise level',
    'compareLayer.technicalData.notAvailable': 'Unfortunately, the technical data is currently not available due to maintenance work. We apologize for any inconvenience.',
    'compareLayer.technicalData.performanceData': 'Performance Data',
    'compareLayer.technicalData.section.consumptionAndEmission.eecTitle': 'CO₂ Efficiency class',
    'compareLayer.technicalData.section.consumptionAndEmission.eecTaxLabel': 'Annual tax for this vehicle',
    'compareLayer.technicalData.section.consumptionAndEmission.eecRemark': 'Remark for the EEC Label',
    'compareLayer.technicalData.section.consumptionAndEmission.eecConsumptionPriceLabelValues': 'Electricity costs for a mileage of {{mileage}} km at an electricity price of {{electricityPrice}} Euro/kWh',
    'compareLayer.technicalData.steeringSystem': 'Steering',
    'compareLayer.technicalData.trailerWeightLimit': 'Trailer Weight Limit',
    'compareLayer.technicalData.volumes': 'Volumes',
    'compareLayer.technicalData.weights': 'Weights',
    'compareLayer.a11y.footnotes.technicalData': 'Technical data footnote for {{technicalDataItem}}. Scrolls to the corresponding text',
    'compareLayer.standardEquipment.sections.WHEELS': 'Wheels',
    'compareLayer.standardEquipment.sections.LIGHTS': 'Lights',
    'compareLayer.standardEquipment.sections.MATERIALS': 'Materials',
    'compareLayer.standardEquipment.sections.STEERING_WHEELS': 'Steering Wheels',
    'compareLayer.standardEquipment.sections.SEATS': 'Seats',
    'compareLayer.a11y.footnotes.cae': 'Consumption and emission footnote. Scrolls to the corresponding text',
    'ngc.dialogs.features': 'Features',
    'ngc.dialogs.benefits': 'Benefits',
    'ngc.technicalData.wltpLink': 'What is WLTP?',
    'ngc.dialogs.euTyreLabel.disclaimer': 'It is not possible to order a specific make of tyre for logistical and production reasons.',
    'ngc.dialogs.euTyreLabel.linkText': 'Information on EU tire labeling',
    'ngc.dialogs.euTyreLabel.linkURL': '',
    'ngc.dialogs.euTyreLabel.description': 'EU tire label showing the fuel efficiency class, wet grip class and the external rolling noise class and value.s',
    'ngc.actions.productDataSheet': 'Product data sheet',
};
